import React from 'react'
import homeimg from '../images/home/home.jpg'

export default function Home({ id }) {
    return (
        <>
            <div id={id} className='w-full h-screen overflow-hidden relative'>
                {/* Background Image with Overlay */}
                <div className='absolute top-0 left-0 w-full h-full'>
                    <div className='w-full h-full bg-black/60 absolute left-0 top-0'></div>
                    <img src={homeimg} alt="background image" className='w-full h-full object-cover' />
                </div>

                {/* Content Section */}
                <div className='absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-20 w-full flex flex-col justify-center items-center px-6 sm:px-12 md:px-24 lg:px-36 text-white'>
                    
                    {/* Main Heading */}
                    <h1 className='text-[2rem] sm:text-[3rem] md:text-[4rem] font-["robecha-daniera"] text-white tracking-tight p-2 uppercase text-center'>
                        coming soon 
                        <span className='animate-ping text-[4rem] sm:text-[5rem] md:text-[7rem]'>...</span>
                    </h1>

                    {/* Subheading */}
                    <h1 className='text-[2rem] sm:text-[2.5rem] md:text-[3.5rem] font-["robecha-daniera"] text-white tracking-tight p-2 text-center'>
                        Welcome to Homeland's Premier Commercial Project
                    </h1>

                    {/* Paragraph */}
                    <p className='text-base sm:text-lg md:text-xl text-center p-2'>
                        Discover the future of commerce with Homeland's upcoming commercial project, a sprawling 15-acre township designed to elevate your business. Boasting a massive 1000 ft frontage, this project blends accessibility, modern infrastructure, and prime location to create the ideal business environment. Whether you're looking to establish a retail outlet or corporate office, Homeland's commercial township offers the perfect setting for growth and success.
                    </p>
                    
                </div>
            </div>
        </>
    )
}
